export const form_value = {
  estimateInputText: "I want to develop a new HR system. The system will be developed by a team of 4 software developers, 2 HR specialists, 2 Project managers. The deadline is in 12 months. The system should be able to track people's worked hours, and time off."
};
